'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M0 232l0 48 104 0 0-48-104 0zM58 92c7.5 7.5 26.4 26.4 56.6 56.6l17 17 33.9-33.9c-7.5-7.5-26.4-26.4-56.6-56.6L92 58 58 92zM58 420L92 454c7.5-7.5 26.4-26.4 56.6-56.6l17-17-33.9-33.9C124 354 105.1 372.9 75 403.1L58 420zM232 0l0 104 48 0 0-104-48 0zm0 408l0 104 48 0 0-104-48 0zM346.5 131.5l33.9 33.9c7.5-7.5 26.4-26.4 56.6-56.6L454 91.9 420 58c-7.5 7.5-26.4 26.4-56.6 56.6l-17 17zm0 248.9l73.5 73.5 33.9-33.9-73.5-73.5-33.9 33.9zM408 232l0 48 104 0 0-48-104 0z', 'M144 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;